export default __webpack_public_path__ + "static/media/ret-res13.28127070.jpg";